<template>
  <b-container>
    <b-row class="p-3">
      <b-col md="6" class="text-center d-flex flex-column justify-content-center">
        <p class="m-0">Still not convinced? Reach out.</p>
      </b-col>
      <b-col md="6" class="text-center">
        <b-button variant="primary" size="md">Contact</b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
name: "FooterBanner"
}
</script>

<style scoped lang="scss">
  p {
    color: $white;
    font-size: 24px;
    font-weight: 500;
  }
</style>